import Ajax from "@/common/ajax";
import {ApiExistUnreadNotifications, ApiNotifications, ApiNotificationsCount} from "@/const";

export default {
    getNotifications(data: {page: number}, success: any) {
        Ajax.get(ApiNotifications, data, success, () => false)
    },
    deleteNotification(data: {id: string}, success: any, failure: any) {
        Ajax.delete(ApiNotifications+'/'+data.id, success, failure)
    },
    getNotificationCount(success: any) {
        Ajax.get(ApiNotificationsCount, {}, success, () => false)
    },
    checkUnreadNotifiactions(success: any) {
        Ajax.get(ApiExistUnreadNotifications, {}, success, () => false)
    }
}